import create from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { createContext } from "react";

const AuthBasicContext = createContext("");

const AuthBasicUtilityContext = create(subscribeWithSelector((set, get) => ({
    authToken: null,
    isAuthenticated: false,
    setToken: (token) => {
        set({ authToken: token })
    },
    setIsAuthenticated: (state) => {
        set({ isAuthenticated: state })
    }
})))


export {
    AuthBasicContext,
    AuthBasicUtilityContext
}